import React, { useContext, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, AuthContext } from './AuthContext';
import Navigation from './Navigation';
import Login from './Login';
import Register from './Register';
import LegacyMigrate from './legacyMigrate'; // Import der neuen Seite
import PasswordReset from './PasswordReset';
import ResetPassword from './resetPassword'; // Neue ResetPassword-Komponente importieren
import Dashboard from './Dashboard';
import VariousFeedback from './variousFeedback';
import Admin from './Admin';
import TextMining from './TextMining';
import User from './User';
import CustomerFeedback from './customerFeedback';
import Feedback from './feedback';
import Team from './Team';
import Profile from './Profile';
import Status from './Status';
import NewPassword from './newPassword'; // Neue Passwort-Änderungsseite importieren
import Pending from './Pending'; // Import the Pending component
import FeedbackSelectionExport from './FeedbackSelectionExport'; // Import der neuen FeedbackSelectionExport-Komponente
// eslint-disable-next-line
import { translate, setLanguage } from './translateFunction'; // Import translate and setLanguage functions


// Layout-Komponente, die Header, Footer und Navigation bedingt rendert
const Layout = ({ children }) => {
  const location = useLocation();
  const hideNavigation = location.pathname === '/feedback' || location.pathname === '/change-password';
  // eslint-disable-next-line
  const { user } = useContext(AuthContext);
  // eslint-disable-next-line
  const [currentLanguage, setCurrentLanguageState] = useState('DE'); // Default language

  const handleLanguageChange = (lang) => {
    setCurrentLanguageState(lang);
    setLanguage(lang); // Change the global language using the setLanguage function from translateFunction.js
    // Force a reload of translations to apply the new language
    window.location.reload();
  };

  return (
    <>
      {!hideNavigation && <Navigation />}
      <div className="App">
        <main>{children}</main>
        <footer className="container-fluid footer-custom">
          <div className="flex-div-legend">
            {/* <img src="/Content/themes/base/images/logo.png" alt="Logo" /> */}
            <div className="flex-vertical">
              <p><span style={{ fontSize: '0.8em', fontStyle: 'italic' }}> «ClientEcho» In collaboration with  </span><br /><span style={{ fontSize: '1.0em', fontStyle: 'bold' }}> Swisscom Business | Analytics & Data | 2025</span> </p>
            </div>
          </div>
          <div className="language-selection">
            <button onClick={() => handleLanguageChange('DE')} style={{ background: 'none', border: 'none', padding: 0, margin: 0, color: 'blue', textDecoration: 'none', cursor: 'pointer' }}>
              Deutsch
            </button>
            |
            <button onClick={() => handleLanguageChange('EN')} style={{ background: 'none', border: 'none', padding: 0, margin: 0, color: 'blue', textDecoration: 'none', cursor: 'pointer' }}>
              English
            </button>
            |
            <button onClick={() => handleLanguageChange('FR')} style={{ background: 'none', border: 'none', padding: 0, margin: 0, color: 'blue', textDecoration: 'none', cursor: 'pointer' }}>
              Français
            </button>
          </div>

        </footer>
      </div>
    </>
  );
};

// Geschützte Route-Komponente, die den Zugriff auf authentifizierte Benutzer beschränkt
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <div>Loading...</div>;

  if (!user) return <Navigate to="/login" />;

  // Verhindern, dass Benutzer ohne Teamzuweisung auf geschützte Seiten zugreifen
  if (user.teamId === 0) {
    return <Navigate to="/pending" />;
  }

  return children;
};


function App() {
  const { loading, user } = useContext(AuthContext);

  if (loading) {
    return <div>Loading user data...</div>;
  }

  return (
    <Router>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/password-reset" element={<PasswordReset />} />
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/status" element={<Status />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/resetPassword" element={<ResetPassword />} />

            {/* Neue Route für Legacy-Migration */}
            <Route path="/legacy-migrate" element={<ProtectedRoute><LegacyMigrate /></ProtectedRoute>} />


            {/* Neue Route für Passwortänderung */}
            <Route path="/change-password" element={<ProtectedRoute><NewPassword /></ProtectedRoute>} />

            {/* Neue Route für Benutzer ohne Teamzuweisung */}
            <Route path="/Pending" element={<Pending />} />


            {/* Geschützte Routen */}
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/variousFeedback" element={<ProtectedRoute><VariousFeedback /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="/textmining" element={<ProtectedRoute><TextMining /></ProtectedRoute>} />
            <Route path="/user" element={<ProtectedRoute><User /></ProtectedRoute>} />
            <Route path="/customerFeedback" element={<ProtectedRoute><CustomerFeedback /></ProtectedRoute>} />
            <Route path="/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />

            {/* Neue Profil-Route */}
            <Route path="/profile/:id" element={<ProtectedRoute><Profile user={user} /></ProtectedRoute>} />

            {/* Neue Route für FeedbackSelectionExport */}
            <Route path="/feedback-selection-export" element={<ProtectedRoute><FeedbackSelectionExport /></ProtectedRoute>} />
          </Routes>
        </Layout>
      </AuthProvider>
    </Router>
  );
}

export default App;
